/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * Neubie Order
 * Neubie Order API Server
 * OpenAPI spec version: V1
 */

/**
 * * `ALREADY_MAIN_PRODUCT_CATEGORY_EXISTS` - 대표 상품 종류가 이미 있습니다.
 * `PRODUCT_CATEGORY_NAME_OVER_MAX_LENGTH` - 상품 종류 이름이 최대 입력 크기를 넘었습니다.
 */
export type AdminProductCategoryCreate400ExceptionCodeEnum =
  (typeof AdminProductCategoryCreate400ExceptionCodeEnum)[keyof typeof AdminProductCategoryCreate400ExceptionCodeEnum]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProductCategoryCreate400ExceptionCodeEnum = {
  ALREADY_MAIN_PRODUCT_CATEGORY_EXISTS: 'ALREADY_MAIN_PRODUCT_CATEGORY_EXISTS',
  PRODUCT_CATEGORY_NAME_OVER_MAX_LENGTH: 'PRODUCT_CATEGORY_NAME_OVER_MAX_LENGTH'
} as const
